'use strict';

module.exports = function (ngModule) {
    ngModule.controller('filesByMimeController', require('./files_by_mime'));
    ngModule.controller('filesByMimeTypeController', require('./files_by_mime_type'));
    ngModule.controller('filesByFileNameController', require('./files_by_mime_type_filename'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/files/index.js
 **/